import React, { useContext } from "react";
import { debug } from "../utils";
import DevicesTableRow from "./DevicesTableRow";
import { connect } from "react-redux";
import { CheckboxTable } from "../view/CheckboxTable";
import { useDeviceTableHelper } from "./useDeviceTableHelper";
import { TableContext } from "../index";
import DevicesTableRowSkeleton from "./DevicesTableRowSkeleton";

function DevicesTable({ devices = [] }) {

    const devicesTableHelper = useDeviceTableHelper();
    const { config } = useContext(TableContext);

    const headers = [
        { name: 'HOST', sortKey: 'hostName', onClick: () => devicesTableHelper.onHostClick() },
        { name: 'IP ADDRESS' },
        { name: 'STATUS', sortKey: 'status', onClick: () => devicesTableHelper.onStatusClick() },
        { name: 'COMPLIANT', sortKey: 'pciCompliance', onClick: () => devicesTableHelper.onCompliantClick() },
        { name: 'ENABLED' }
    ]

    // Client-side search filtering on hostname and IP address
    const searchTerm = (config.searchTerm || '').toLowerCase();
    const filteredDevices = searchTerm
        ? devices.filter(device => {
            const hostName = (device.hostName || '').toLowerCase();
            const ipAddress = (device.mngtIpAddress || '').toLowerCase();
            return hostName.includes(searchTerm) || ipAddress.includes(searchTerm);
        })
        : devices;

    return (
        <>
            <CheckboxTable headers={headers} elements={filteredDevices}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <DevicesTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredDevices.map((device, index) => <DevicesTableRow key={index} data={device} index={index} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredDevices.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("DevicesTable mapStateToProps", state);
    const devicesPage = state.devicesPage;
    return {
        devices: devicesPage.devices || []
    };
}

export default connect(mapStateToProps)(DevicesTable);
